const DefaultAML = () => {
	return (
		<svg width='100%' height='100%' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M19.5901 2.86065C20.8837 1.86806 22.6809 2.05344 23.7632 3.27297C27.3859 7.35493 34.916 16.4739 34.9161 21.7479C34.916 30.3389 29.3404 37.3034 20.7495 37.3034C12.2925 37.3034 5.4115 30.5545 5.19879 22.1488C4.6319 17.2647 5.39056 12.2493 6.05925 9.11064C6.44051 7.32168 8.26682 6.34957 9.98123 6.98716C10.9434 7.34508 12.0665 7.7863 13.2581 8.30118C15.5823 6.04428 17.934 4.13136 19.5901 2.86065ZM20.7462 18.9305C20.3618 18.6074 19.8112 18.6074 19.4268 18.9305C17.9547 20.1681 14.5311 23.3021 14.5309 25.6824C14.5309 28.7144 17.0183 31.1727 20.0865 31.1728C23.1547 31.1728 25.642 28.7145 25.642 25.6824C25.6419 23.302 22.2181 20.1679 20.7462 18.9305Z'
				fill='#D0D2DC'
			/>
		</svg>
	);
};

export default DefaultAML;
